import { BasicDialogService } from './basic-dialog.service';
import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'basic-dialog',
  templateUrl: './basic-dialog.component.html',
  styleUrls: ['./basic-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BasicDialogComponent implements OnInit, OnDestroy {

  @Input() id: string;
  @Input() dialogSize: string = 'md';

  private element: any;

  constructor(private basicDialogService : BasicDialogService, private el:ElementRef) { 
    this.element = el.nativeElement;
  }

  ngOnInit():void {
    let dialog = this;

    // ensure id attribute exists
    if (!this.id) {
      console.error('dialog must have an id');
      return;
    }

    // move element to bottom of page (just before </body>) so it can be displayed above everything else
    document.body.appendChild(this.element);

    // close dialog on background click
    this.element.addEventListener('click', function (e: any) {
      if (e.target.className === 'dialog') {
        dialog.close();
      }
    });

    // add self (this dialog instance) to the dialog service so it's accessible from controllers
    this.basicDialogService.add(this);
  }
  // remove self from dialog service when directive is destroyed
  ngOnDestroy(): void {
    this.basicDialogService.remove(this.id);
    this.element.remove();
  }

  // open dialog
  open(): void {
    this.element.style.display = 'block';
    document.body.classList.add('dialog-open');
  }

  // close dialog
  close(): void {
    this.element.style.display = 'none';
    document.body.classList.remove('dialog-open');
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/basic-dialog/basic-dialog.component.ts